import _classCallCheck from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component, PropTypes } from 'react';
import styles from '../../build/styles';
import { getCallbacks } from '../helper/helper';

var Group =
/*#__PURE__*/
function (_Component) {
  _inherits(Group, _Component);

  function Group() {
    _classCallCheck(this, Group);

    return _possibleConstructorReturn(this, _getPrototypeOf(Group).apply(this, arguments));
  }

  _createClass(Group, [{
    key: "createControlClassName",
    value: function createControlClassName() {
      return [styles.control, styles.isGrouped, this.props.className].join(' ').trim();
    }
  }, {
    key: "cloneWithProps",
    value: function cloneWithProps() {
      if (React.Children.count(this.props.children) < 2) {
        return React.createElement('p', {
          className: styles.control
        }, this.props.children && React.cloneElement(this.props.children, {
          hasAddons: true
        }));
      }

      return this.props.children.map(function (child, i) {
        return React.createElement('p', {
          key: i,
          className: "".concat(styles.control, " ").concat(child.props.isExpanded ? styles.isExpanded : '')
        }, React.cloneElement(child, {
          hasAddons: true
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement('div', _extends({
        className: this.createControlClassName(),
        style: this.props.style
      }, getCallbacks(this.props)), this.cloneWithProps());
    }
  }]);

  return Group;
}(Component);

export { Group as default };
Group.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.any
};
Group.defaultProps = {
  style: {},
  className: ''
};